export default __webpack_public_path__ + "media/images/react_icons/share_icon-51759f0d661eed6acadb73783b8261e4.svg";